<div class="chat-container">
  <div class="chat-header">
    <div class="header-left">
      <button mat-icon-button (click)="toggleHistory()" title="{{ 'chatbot.history' | translator }}">
        <mat-icon>history</mat-icon>
      </button>
      <div class="ai-logo">
        <mat-icon>auto_awesome</mat-icon>
        <div class="logo-content">
          <span class="logo-name">LEO Assistant</span>
          @if (currentItemDetails(); as details) {
            <span class="item-title">
              {{ details.type === 'motor' ? ('engines.engine' | translator) : ('home.equipment' | translator) }}: 
              {{ details.brand }} {{ details.model }} 
              ({{ details.serialNumber }})
            </span>
          }
        </div>
      </div>
    </div>
    <div class="header-right">
      <button mat-icon-button (click)="createNewConversation()" title="{{ 'chatbot.new' | translator }}">
        <mat-icon>add_comment</mat-icon>
      </button>
    </div>
  </div>

  <div class="chat-body">
    @if (showHistory) {
      <div class="chat-history-sidebar">
        <div class="history-title">{{ 'chatbot.history' | translator }}</div>
        <div class="history-list">
          @for (conv of sortedConversations; track conv.id) {
            <div 
              [class.active]="conv.id === chatbotService.currentConversationId()"
              class="history-item" 
              (click)="selectExistingConversation(conv.id); toggleHistory()">
              <mat-icon>chat_bubble_outline</mat-icon>
              <span class="conv-title">{{ conv.title }}</span>
              <button mat-icon-button class="delete-btn" (click)="deleteConversation($event, conv.id)">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    }

    <div class="messages-viewport" #scrollContainer>
      @for (msg of messages; track msg.timestamp) {
        <div [class]="'message-wrapper ' + msg.role">
          @if (msg.role === 'assistant') {
            <div class="avatar">
              <span class="material-symbols-outlined">robot_2</span>
            </div>
          }
          <div class="message-bubble">
            <div class="content" [innerHTML]="getMarkdown(msg.content)"></div>
            
            @if (msg.pending_interrupt) {
              <div class="interrupt-container">
                <p class="interrupt-question">{{ msg.pending_interrupt.question || ('chatbot.confirmation' | translator) }}</p>
                <div class="interrupt-actions">
                  <button mat-stroked-button color="primary" (click)="respondInterrupt('yes')">{{ 'chatbot.yes' | translator }}</button>
                  <button mat-stroked-button color="warn" (click)="respondInterrupt('no')">{{ 'chatbot.no' | translator }}</button>
                </div>
              </div>
            }

            <div class="timestamp">{{ msg.timestamp | date:'HH:mm' }}</div>
          </div>
        </div>
      }
      @if (isLoading) {
        <div class="message-wrapper assistant">
          <div class="avatar">
            <span class="material-symbols-outlined">robot_2</span>
          </div>
          <div class="message-bubble loading">
            <div class="typing-indicator">
              <span></span><span></span><span></span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <div class="input-area">
    <div class="input-wrapper">
      <textarea
        matInput
        placeholder="{{ 'chatbot.placeholder' | translator }}"
        [(ngModel)]="newMessage"
        (keyup.enter)="sendMessage()"
        rows="1"
      ></textarea>
      <button mat-icon-button color="primary" (click)="sendMessage()" [disabled]="!newMessage.trim()">
        <mat-icon>send</mat-icon>
      </button>
    </div>
    <div class="disclaimer">
      {{ 'chatbot.disclaimer' | translator }}
    </div>
  </div>
</div>
